<template>
	<div id="">
		<div class="list_ma">
			<div class="list_box p_flex p_f_a p_b_b" v-for="(item, index) in count" :key="index" @click="goDeatils(item.type,item.id)" infinite-scroll-disabled="disabled">
				<div class="list_img">
					<img v-if="item.type == 1 && item.teacher_unread==0?true : false" src="../../../../assets/img/blue.png" />
					<img  v-if="item.type == 2 &&  item.teacher_unread==0?true : false"  src="../../../../assets/img/orange.png" />
					<img  v-if="item.type == 3 && item.teacher_unread==0?true : false"  src="../../../../assets/img/green.png" />
					<el-badge v-if="item.type == 1?true : false" :value="item.teacher_unread" v-show="item.teacher_unread==0?false:true" class="item" :max="99">
						<img  src="../../../../assets/img/blue.png" />
					</el-badge>
					<el-badge v-if="item.type == 3?true : false" :value="item.teacher_unread" v-show="item.teacher_unread==0?false:true" class="item" :max="99">
						<img  src="../../../../assets/img/green.png" />
					</el-badge>
					<el-badge v-if="item.type == 2?true : false" :value="item.teacher_unread" v-show="item.teacher_unread==0?false:true" class="item" :max="99"> 
						<img  src="../../../../assets/img/orange.png" />
					</el-badge>
				</div>
				<div class="p_m_l_60 p_f_1">
					<span v-if="item.type == 3 ?true : false" class="p_m_t_14 one-overflow type_size_16">
						{{item.title}}
					</span>
					<div v-else>
						<div class="p_flex p_f_a ">
							<span class="type_size_18">{{item.student.name}}</span>
							<span class="p_m_l_30">{{item.enquire_date}}</span>
						</div>
						<span class="p_m_t_14 one-overflow type_size_16">
							{{item.student_content}}
						</span>
					</div>
				</div>
			</div>
			
		</div>
		<pagination @get="get" :index="num"/>
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue'
export default {
	data() {
		return {
			count: [],
			loading: false,
			num:0
		};
	},
	components:{
		pagination
	},
	created(){
		this.get()
	},
	mounted() {},
	methods: {
		get(id){
			this.$request.ajax(this).post("/api_teacher/news_list",{
					page:id?id:1,
					limit:10
			}).then(res=>{
				// console.log(res)
				this.num=parseInt(res.data.count)
				this.count=res.data.list
			})
		},
		goDeatils(i,o){
			if( i == 1 ){
				this.$router.push({
					path:'/NewsError',
					query: {
						id:o,
						num:1
					}
				});
				return
			}
			if( i == 3 ){
				this.$router.push('/Rest');
				return
			}
			this.$router.push({
				path:'/Student',
				query: {
					id:o
				}	
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
}
.list_ma {
	margin: 0 260px 50px;
}
.list_img {
	width: 60px;
	height: 60px;
}
>>> .el-badge__content {
	background-color: #f1282e;
}
img{
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/news/commponents/indexList.vue